import * as z from 'zod';

export const marketingCampaignQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
});

export type MarketingCampaignQueryLinkerSchema = z.infer<typeof marketingCampaignQueryLinkerSchema>;
